enum Plan {
  GUEST = 1,
  FREE = 2,
  LIGHT = 3,
  SAFETY = 4,
  PRO = 5,
  ENTERPRISE = 6
}

// tslint:disable-next-line:no-namespace
namespace Plan {
  export function info(plan: Plan): PlanInfo {
    switch (plan) {
      case Plan.LIGHT:
        return { name: 'お手軽プラン', price: '7321', priceWithTax: '8053', limit: '50人まで' }
      case Plan.SAFETY:
        return { name: '安心プラン', price: '13807', priceWithTax: '15187', limit: '300人まで' }
      case Plan.PRO:
        return { name: 'プロプラン', price: '30000', priceWithTax: '33000', limit: '500人まで' }
      case Plan.ENTERPRISE:
        return { name: 'エンタープライズプラン', price: '50000', priceWithTax: '55000', limit: '1000人まで' }
      case Plan.FREE:
        return { name: '無料プラン', price: '0', priceWithTax: '0', limit: '10人まで' }
      default:
        throw new Error('予期せぬプランです。')
    }
  }
}

interface PlanInfo {
  name: string
  price: string
  priceWithTax: string
  limit: string
}

export { Plan, PlanInfo }
